import $ from 'jquery';
import ScrollMagic from 'scrollmagic';
import 'slick-carousel';
import Util from '../utils/ui';
import * as CONST from '../utils/constants';
import analytics from '../utils/analytics';

class Home {
	constructor() {
		this.controller = new ScrollMagic.Controller();
		this.expandStat = $('.js-expand-stat');
		this.$expandedContent = $('.js-expanded-impact');
        this.$closeExpandedContent = $('.js-close-expanded-impact');
        this.$homeInitiatives = $('.home-initiatives');
        this.$sectionImpactList = $('.cta-plus-link');
        this.$promoCTA = $('.promo-card-ctas');
        this.$heroCTA = $('.hero-content-ctas');
        this.$sectionCTA = $('.section-header-cta a');
	}

	init() {
		this.bindEvents();

		this.cardSlider();
		this.scrollFeatureStat();
	}

	bindEvents() {	
		this.expandStat.on('click', e => { this.toggleExpandedContent(e); });
        this.$closeExpandedContent.on('click', e => { this.closeExpandedContent(e); });
        this.$homeInitiatives.on('click', e => { this.cardAnalytics(e); });
        this.$sectionImpactList.on('click', e => { this.sectionImpactAnalytics(e); });
        this.$promoCTA.on('click', e => { this.heroPromoCTAAnalytics(e, 'Promo Section'); });
        this.$heroCTA.on('click', e => { this.heroPromoCTAAnalytics(e, 'Hero Section'); });
        this.$sectionCTA.on('click', e => { this.sectionCTAAnalytics(e); });
	}

	cardSlider(e) {
		$('.card-slider:not(".single-card")').slick({
			infinite: false,
			dots: true,
			arrows: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			mobileFirst: true,
			responsive: [
				{
					breakpoint: 970,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
						dots: false,
					}
				},
				{
					breakpoint: 750,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
						dots: true,
					}
				},
			]
		});
	}

	closeExpandedContent(e) {
		this.expandStat.removeClass('active');
		$('.section-impact-expanded').removeClass('active');
		$('body').removeClass('stat-open');
		$('.section-impact-wrap').css('opacity', '0');

		if (Util.getViewPort() !== CONST.ViewPort.Desktop) {
			//$('html').scrollTop(this.$scrollTop);
		}

		this.$expandedContent.html('');
	}

	toggleExpandedContent(e) {
		const target = $(e.currentTarget);
		const expanded = $(target).closest('.stat-story-callout').find('.stat-story-callout-expand').html();

		this.expandStat.removeClass('active');
		$(target).addClass('active');

		$('.section-impact-expanded').addClass('active');
		const delay = (Util.getViewPort() === CONST.ViewPort.Desktop) ? 800 : 100;
		setTimeout(() => {
			$('.section-impact-wrap').css('opacity', '1');
		}, delay);
		
		this.$scrollTop = $('html').scrollTop();
		this.$expandedContent.html($(expanded));
	}

	scrollFeatureStat() {
		//scroll-feature-stat-up
		let scene = new ScrollMagic.Scene({
			triggerElement: '.scroll-feature-stat-up',
			offset: 50,
			triggerHook: 5,
			reverse: false,
		})
			.on('enter', (e) => {
				let $this = $('.section-impact-feature .stat');
				let countTo = $this.attr('data-count');

				$({ countNum: $this.text() }).animate({
					countNum: countTo
				},
					{
						duration: 1000,
						easing: 'linear',
						step() {
							$this.text(Math.floor(this.countNum));
						},
						complete() {
							$this.text(this.countNum);
						}
					});
			})
			.setClassToggle('.scroll-feature-stat-up', 'visible') // add class toggle
			.addTo(this.controller);
    }

    cardAnalytics(e) {
        const card = $(e.target).closest('.card-outer');
        const title = $(card).find('h3').text();
        const link = $(card)[0].href;
        analytics.cardClick('Current Initiatives and Updates', 'Card', title, link, 'not set');
    }

    sectionImpactAnalytics(e) {
        const callout = $(e.target).closest('.stat-story-callout');
        const title = $(callout).find('.cta-plus-link').text();
        const learnMore = $(callout).find('.large-feature-txt')[0].innerText;
        analytics.cardClick('Impact', 'CTA', title, 'not set', learnMore);
    }

    heroPromoCTAAnalytics(e, section) {
        const target = $(e.target);
        const text = $(target).text();
        const link = $(target)[0].href;
        analytics.cardClick(section, 'CTA', text, link, 'not set');
    }

    sectionCTAAnalytics(e) {
        const target = $(e.target);
        const section = target.parents('.section-header').find('.section-header-txt').find('h2').text();
        const text = target.text();
        const link = $(target)[0].href;
        analytics.cardClick(section, 'CTA', text, link, 'not set');
    }
}

export default Home;